<template>
  <div id="propelling">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/skillList' }">技能列表</el-breadcrumb-item>
      <el-breadcrumb-item>推送申请</el-breadcrumb-item>
    </el-breadcrumb>
    <p class="title">推送申请
      <el-tooltip content="开发者提交推送申请，申请内容将进入猎户推送素材库，运营人员会根据推送内容质量择优进行推送" placement="top">
        <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
      </el-tooltip>
    </p>
    <div class="propellingCon">
      <div style="border-bottom: 1px solid #eee;padding-bottom: 20px;margin-bottom: 30px;overflow: hidden;">
        <div class="propell-left">
          <el-form ref="form" label-width="100px" :rules="propelling" :model="pushInfo">
            <el-form-item label="推送标题：" prop="title">
              <el-tooltip content="用于标识推送标题，不会推送到用户" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
              <el-input v-model.trim="pushInfo.title" placeholder="请输入您的推送标题" @input.native="changeRoute"></el-input>
            </el-form-item>
            <el-form-item label="播报文案：" prop="tts_content">
              <el-tooltip content="该文案会以语音形式在音箱端播报，与用户产生真实交互，可以通过试听功能预览交互场景" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" name="tabs" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
              <el-input v-model.trim="pushInfo.tts_content" type="textarea" :autosize="{ minRows: 6}"
                        placeholder="请输入语音播报文案,1~200个汉字，智能设备用户将会接收该文案的语音播报通知" @input.native="changeRoute"></el-input>
            </el-form-item>
            <el-form-item label="资源名称：">
              <el-tooltip content="点播资源名称" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
              <el-input v-model.trim="pushInfo.resource_name" placeholder="请输入音频资源名称" @input.native="changeRoute"></el-input>
            </el-form-item>
            <el-form-item label="点播资源：">
              <!--支持MP3、WAV、M4A，大小不超过50M。点播资源会在语音播报完成后会自动触发播放-->
              <el-tooltip content="点播资源名称url" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
              <el-input v-model.trim="pushInfo.resource" placeholder="请输入音频资源url" @input.native="changeRoute"></el-input>
            </el-form-item>
            <el-form-item label="推送时间：" prop="begin_time">
              <el-tooltip content="期望推送时间并不代表实际推送时间，指定时间选择最长时间跨度3天" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
              <div>
              </div>
              <div id="propellingTime">
                <el-button round size="mini" @click="timeType(1)" :style=[!show3?blur:null]>任意
                </el-button>
                <el-button round size="mini" @click="timeType(2)" :style=[show3?blur:null]>指定时间
                </el-button>
                <div v-show="show3">
                  <template>
                    <div class="inline-block">
                      <span class="demonstration">开始时间</span>
                      <el-date-picker
                        v-model="pushInfo.begin_time"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions1"
                        value-format="yyyy-MM-dd HH:mm:ss">
                        >
                      </el-date-picker>
                      <span class="demonstration">结束时间</span>
                      <el-date-picker
                        v-model="pushInfo.end_time"
                        type="date"
                        placeholder="选择日期"
                        :disabled="pushInfo.begin_time == ''"
                        :picker-options="pickerOptions2"
                        value-format="yyyy-MM-dd HH:mm:ss">
                        >
                      </el-date-picker>
                    </div>
                  </template>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="推送人群：" prop="group">
              <el-tooltip content="期望推送的人群画像，描述越精准，推送转化率越高" placement="top">
                <i class="icon iconfont icon-wenhao blurIcon" :tabindex="tabindexNumChange()"></i>
              </el-tooltip>
              <el-input type="textarea" v-model.trim="pushInfo.group" :autosize="{ minRows: 6}"
                        placeholder="请输入您希望推送给哪些用户（年龄，性别，消费能力，有哪些行为特征）" @input.native="changeRoute"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div class="propell-right listen">
          <img id="listenImg" :src="imgSrc" alt="">
          <audio :src="audio_url" autoplay id="audio"></audio>
          <el-button id="listenbtn" type="primary" round size="mini" @click="listen(listenVal)">
            {{listenVal}}
          </el-button>
        </div>
      </div>

      <div class="col-md-12 text-center">
        <el-button id="pushbtn" class="intentSavebtn" :disabled="!pushInfo.title || !pushInfo.tts_content || !pushInfo.group" size="mini" type="primary" round @click="push">提交申请</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import qs from 'qs'
  import {pushApi, getUserId, ttsApi} from '@/api'

  export default {
    data() {
      var checkChinese = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          if (!reg.test(value)) {
            callback(new Error('请填写正确的推送标题，2~50个汉字'));
          } else {
            callback();
          }
        }, 100);
      }
      var checkChinese1 = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          if (!reg.test(value)) {
            callback(new Error('请填写正确的语音播报文案，1~200个汉字'));
          } else {
            callback();
          }
        }, 100);
      }
      var checkChinese2 = (rule, value, callback) => {
        setTimeout(() => {
          var reg = new RegExp("^[\u4e00-\u9fa5]+$");
          if (!reg.test(value)) {
            callback(new Error('请填写正确的推送人群，1~500个汉字'));
          } else {
            callback();
          }
        }, 100);
      }
      return {
        begindate: '',
        enddate: '',
        show3: false,
        blur: {'background': '#409EFF', 'color': '#fff'},
        pushInfo: {
          title: '',
          tts_content: '',
          resource: '',
          resource_name: '',
          time_type: 1,
          begin_time: '',
          end_time: '',
          group: ''
        },
        audio: false,
        listenVal: '试听',
        audio_url: '',
        pickerOptions1: {
          disabledDate: (time) => {
            return time.getTime() <  new Date() - 3600*1000*24
          }
        },
        pickerOptions2: {
          disabledDate: (time) => {
            let beginTime = new Date(this.pushInfo.begin_time.substr(0, 10)).getTime()
            return time.getTime() < (beginTime - 86400000) || time.getTime() > (beginTime + 172800000)
          }
        },
        local: false,
        imgSrc: "../../../static/images/skill/pro1.png",
        propelling: {
          title: [
            {required: true, message: '请输入您的推送标题', trigger: 'blur'},
            {min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur'},
            {validator: checkChinese, trigger: 'blur'}
          ],
          tts_content: [
            {required: true, message: '请输入语音播报文案,1~200个汉字', trigger: 'blur'},
            {min: 1, max: 200, message: '长度在 1 到 200 个汉字', trigger: 'blur'},
            {validator: checkChinese1, trigger: 'blur'}
          ],
          begin_time: [
            {required: true, message: '请选择推送时间段'},
          ],
          group: [
            {required: true, message: '请填写正确的推送人群，1~500个汉字', trigger: 'blur'},
            {min: 1, max: 500, message: '长度在 1 到 500 个汉字', trigger: 'blur'},
            {validator: checkChinese2, trigger: 'blur'}
          ],
        },
        tabindexNum:"-1"
      }

    },
    created() {
      this.timeType()
      this.isCanInput()
      this.tabindexNumChange()
    },
    mounted() {
      var audio = document.getElementById('audio')
      let _this = this
      audio.addEventListener('ended', function () {
        _this.listenVal = '试听'
        _this.imgSrc = "../../../static/images/skill/pro1.png"
        _this.audio_url = ''
        _this.audio = false
      }, false);
        $('.icon-wenhao').attr('tabindex',-10)
    },
    methods: {
      changeRoute () {
        this.$store.dispatch('changeR',false);
      },
      tabindexNumChange(){
        this.tabindexNum = "-1"
      },
      timeType(type = 1) { //选择时间，任意，指定时段
        this.pushInfo.time_type = type
        type == 1 ? this.show3 = false : this.show3 = true
      },
      isCanInput() {
        if (localStorage.getItem('onlineFlag') == '1') {
          this.local = true;
        } else {
          this.local = false;
        }
      },
      async push() {
        let res = await getUserId()
        if (res.data.code == 200) {
          this.pushInfo.user_id = res.data.data.id
          let {title, tts_content, time_type, begin_time, end_time, group, resource, resource_name} = {...this.pushInfo}
          let RegUrl = /[a-zA-z]+:\/\/[^\s]*/

          if (time_type == 2) {
            if (!begin_time || !end_time) {
              this.$message.error('请选择指定的时段')
              return
            }
            let beginTime = new Date(begin_time.substr(0, 10)).getTime()
            let endTime = new Date(end_time.substr(0, 10)).getTime()
            if (beginTime - endTime > 0) {
              this.$message.error('结束时间不能小于开始时间')
              return
            } else {
//            console.log((beginTime - endTime) / (1000 * 60 * 60));
              if ((beginTime - endTime) / (1000 * 60 * 60) <= -72) {
                this.$message.error('时间周期不能大于三天')
                return
              }
            }
          }

          if (title == '') {
//            this.$message.error('推送标题不能为空')
            this.$root.scroll_top();
            return
          }
          let reg = /[\u4e00-\u9fa5]/g
          if (!reg.test(title) || title.length < 2 || title.length > 50) {
//            this.$message.error('请填写正确的推送标题，2~50个汉字')
            this.$root.scroll_top();
            return
          }
          if (tts_content == '') {
//            this.$message.error('语音播报文案不能为空')
            this.$root.scroll_top();
            return
          }
          let reg_tts_content = /[\u4e00-\u9fa5,.，。?!？！：:;；#、——“”""''‘’（）()]/g
          if (!reg_tts_content.test(tts_content) || tts_content.length < 1 || tts_content.length > 200) {
//            this.$message.error('请填写正确的语音播报文案，1~200个汉字')
            this.$root.scroll_top();
            return
          }
          if (!RegUrl.test(resource)) {
            if (!resource == '') {
              this.$message.error('请填写正确的点播资源url')
              return
            }
          }
          if (resource_name != '') {
            if (resource_name.length < 2 || resource_name > 50) {
              this.$message.error('请填写正确的资源名称，2~50个字符')
              return
            }
          }
          if (group == '') {
//            this.$message.error('请填写期望推送的人群，描述越精准，推送转化率越高')
            this.$root.scroll_top();
            return
          }
          let reg_group = /[\u4e00-\u9fa5,.，。?!？！：:;；#、——“”""''‘’（）()]/g
          if (!reg_group.test(group) || group.length < 1 || group.length > 500) {
//            this.$message.error('请填写正确的推送人群，1~500个汉字')
            this.$root.scroll_top();
            return
          }
          let result = await pushApi(qs.stringify(this.pushInfo))
          if (result.data.code == 200) {
            this.$message.success('提交推送申请成功')
              // this.skill_id = this.$route.query.skillId
              // this.online = this.$route.query.online
            this.$router.push({path: `/PropellingSuc?skillId=${this.$route.query.skillId}&online=${this.$route.query.online}`})
          } else {
            this.$message.error('提交推送申请失败')
          }
        }
      },
      async listen(v) {
        console.log(v);
        if (v == '停止') {
          this.audio_url = ''
          this.listenVal = '试听'
          this.imgSrc = "../../../static/images/skill/pro1.png"
          return
        }
//        if (this.pushInfo.resource) {
//          let RegUrl = /[a-zA-z]+:\/\/[^\s]*/
//          if (!RegUrl.test(this.pushInfo.resource)) {
//            this.$message.error('请填写正确的点播资源url')
//            return
//          }
//          this.audio_url = this.pushInfo.resource
//          this.audio = !this.audio
//          this.listenVal = this.audio ? '停止' : '试听'
//      } else {
        let reg_tts_content = /[\u4e00-\u9fa5,.，。?!？！：:;；#、——“”""''‘’（）()]/g
        if (this.pushInfo.tts_content == '' || !reg_tts_content.test(this.pushInfo.tts_content) || this.pushInfo.tts_content.length < 1 || this.pushInfo.tts_content.length > 200) {
          this.$message.error('请填写正确的语音播报文案，1~200个汉字')
          return
        } else {
          let res = await ttsApi(qs.stringify({text: this.pushInfo.tts_content}))
          if (res.data.code == 200) {
            this.audio_url = res.data.data.resource_url
            this.audio = !this.audio
            this.listenVal = '停止'
            this.imgSrc = "../../../static/images/skill/pro2.gif"
          } else {
            this.$message.error('请求音频失败')
          }
        }

      }
    }

//    }
  }
</script>
<style rel="stylesheet/scss" lang="scss">
  #propelling {
    padding-top: 0;
    background: #fff;
    min-height: 700px;
    .title {
      height: 64px;
      line-height: 64px;
      padding-left: 30px;
      font-size: 18px;
      font-weight: 900;
      color: #2e4d79;
      border-bottom: 1px solid #f5f5f5;
      border-left: 2px solid #010202;
      .blurIcon {
        color: #7abaf1;
        position: relative;
        right: 0;
      }
    }
    .propellingCon {
      overflow: hidden;
      padding: 20px 30px 30px 30px;
      .propell-left{
        float: left;
        width: 66%;
      }
      .el-input__inner, .el-textarea__inner {
        height: 28px;
        line-height: 28px;
        border-radius: 14px;
      }
      .demonstration {
        margin-left: 10px;
      }
      .transition-box {
        margin-bottom: 10px;
        width: 200px;
        height: 100px;
        border-radius: 4px;
        background-color: #409EFF;
        text-align: center;
        color: #fff;
        padding: 40px 20px;
        box-sizing: border-box;
        margin-right: 20px;
      }
      .blurIcon {
        color: #7abaf1;
      }
      .el-form-item {
        position: relative;
        .blurIcon {
          color: #7abaf1;
          position: absolute;
          left: -20px;
        }
      }
      .listen {
        text-align: center;
        #listenImg {
          width: 326px;
          height: 228px;
          border-radius: 14px;
        }
        #listenbtn {
          display: block;
          margin: 20px auto 0;
          /*width: 110px;*/
        }
      }
      /*#pushbtn{*/
      /*width: 177px;*/
      /*}*/

    }
  }
</style>



// WEBPACK FOOTER //
// src/components/skilloverview/Propelling.vue